import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';

import { DialogConfirmPromptService } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.service';
import {
  SSOSignInParams,
  WorkOsBackend,
} from '@libs/src/workos/workos.backend';

import { Tenant } from '@libs/src/tenant/tenant.interface';

import isEmpty from 'lodash-es/isEmpty';

declare let window: any;

@Component({
  selector: 'app-sso-signin',
  templateUrl: './sso-signin.component.html',
})
export class SsoSigninComponent implements OnInit {
  @Input() tenant: Tenant;
  @Input() ssoErrorMessage = '';
  @Input() ssoErrorStatus: number;
  @Input() ssoSignInParams: SSOSignInParams = {};
  @Input() showPrivacyDisclaimer = false;
  isLoading = false;
  ssoConnectionType = '';
  ssoError: { message?: string; status?: number } = {};

  constructor(
    public confirmDialogPrompt: DialogConfirmPromptService,
    public router: Router,
    public workOsBackend: WorkOsBackend,
  ) {}

  ngOnInit() {
    this.ssoConnectionType = this.getSSOConnectionType(
      this.tenant.integrations?.workos?.sso_connections?.[0]?.connection_type,
    );
    if (this.ssoErrorMessage) {
      this.ssoError = {
        message: this.ssoErrorMessage,
        status: Number(this.ssoErrorStatus),
      };
      if (
        404 === this.ssoError.status &&
        this.tenant.integrations?.workos?.sso_signup_enabled
      ) {
        this.openSSOSignupDialog();
      }
    }
  }

  private openSSOSignupDialog() {
    this.confirmDialogPrompt
      .openDialog({
        cancel: 'Try again',
        color: 'primary',
        confirm: 'Create an account',
        content: `We didn't find your account. Did you mean to create an account instead?`,
        title: `We didn't find your account 🙈`,
      })
      .afterClosed()
      .pipe(
        filter((result) => !isEmpty(result)),
        tap(() => {
          this.router.navigate(['/signup']);
        }),
      )
      .subscribe();
  }

  getSSOConnectionType(connectionType: string) {
    switch (connectionType) {
      case 'GoogleOAuth':
      case 'GoogleSAML': {
        return 'Google';
      }
      case 'AzureSAML': {
        return 'Microsoft';
      }
      case 'OktaSAML': {
        return 'Okta';
      }
      case 'PingFederateSAML':
      case 'PingOneSAML': {
        return 'PingID';
      }
      default: {
        return 'Single sign-on';
      }
    }
  }

  ssoSignIn() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.ssoError = {};
    this.workOsBackend
      .authenticate(this.ssoSignInParams)
      .pipe(
        catchError((response: HttpErrorResponse) => {
          this.isLoading = false;
          this.ssoError = response.error;
          return EMPTY;
        }),
      )
      .subscribe(({ authorizationUrl }) => {
        this.isLoading = false;
        window.location.assign(authorizationUrl);
      });
  }
}
